import { Auth } from "../store/common/auth";

export default function auth({ next, router }) {
  if (!Auth.token) {
    return router.push({ name: "Login" });
  }

  return next();
}
